import React from 'react'

import Header from '../../../components/header'

import * as S from './styles'
import logo from '../../../assets/png/logo-intro.png'
import { getRoute } from '../../../helpers'
import { Authority, RoutesEnum } from '../../../enums'

const ListContestsVacancies = () => (
  <S.Container>
    <Header title="Concursos e Vagas Para Médicos" />

    <S.Logo>
      <img src={logo} alt="Logo" />
    </S.Logo>

    <S.Description>
      Acesse a
      {' '}
      <span className="highlight">
        lista de concursos, processos seletivos e vagas de trabalho
      </span>
      {' '}
      atualizadas semanalmente em todo país.
    </S.Description>

    <S.SubDescription>
      Nas listas você acessa os links com os editais oficiais.
    </S.SubDescription>

    <S.Block1>
      <S.LeftColumn>
        <S.Title>
          Lista de
          {' '}
          <span className="highlight">concursos e Processos seletivos</span>
        </S.Title>
        <S.SubTitle>
          Concursos públicos e processos seletivos para médicos em todo Brasil
        </S.SubTitle>
      </S.LeftColumn>
      <S.RightColumn>
        <S.LinkButton
          to={getRoute(RoutesEnum.CONTESTS_DOCTOR, { type: Authority.DOCTOR })}
          href="#"
        >
          Acessar lista de concursos e processos seletivos
        </S.LinkButton>
      </S.RightColumn>
    </S.Block1>

    <S.Block2>
      <S.LeftColumn>
        <S.Title>
          Lista de
          {' '}
          <span className="highlight">vagas de trabalho</span>
        </S.Title>
        <S.SubTitle>Vagas de trabalho para médicos em todo Brasil</S.SubTitle>
      </S.LeftColumn>
      <S.RightColumn>
        <S.LinkButton
          to={getRoute(RoutesEnum.VACANCIES_DOCTOR, { type: Authority.DOCTOR })}
        >
          Acessar lista de vagas de trabalho
        </S.LinkButton>
      </S.RightColumn>
    </S.Block2>
  </S.Container>
)

export default ListContestsVacancies
